module.exports = __webpack_public_path__ + "assets/img/a3.0b0974f2.png";